var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8589_19345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19731 5.66282L7.23378 9.60532L2.45026 7.2682L6.19731 5.66282Z",
    fill: "#172664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42952 14.8127C6.4289 14.3128 5.12867 13.8127 4.62867 11.3127C4.32929 9.81374 4.92988 7.81282 5.42975 7.31268",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0226 8.15969L12.092 7.07887L16.5132 4.11285L16.0226 8.15969Z",
    fill: "#172664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42716 4.79474C8.00645 4.3209 10.2261 3.64015 12.2269 4.3209C13.6184 4.79434 14.7366 6.14327 14.9185 6.82658",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00084 15.6838L11.7228 12.6492L12.403 17.9295L9.00084 15.6838Z",
    fill: "#172664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9636 9.62068C16.129 10.3506 15.8456 12.4434 14.3432 13.9298C13.2984 14.9636 11.4937 15.5592 10.8011 15.4169",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8589_19345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellCycle);
export default __webpack_public_path__ + "static/media/icn_table_cell_cycle.6c275997f816df8d3c35998ce512cdc7.svg";
export { ForwardRef as ReactComponent };